module.exports = __webpack_public_path__ + "static/media/ledmac-logo.a15127e6.svg";